import { render } from "./DamageResult.vue?vue&type=template&id=51706315&scoped=true&ts=true"
import script from "./DamageResult.vue?vue&type=script&lang=ts"
export * from "./DamageResult.vue?vue&type=script&lang=ts"

import "./DamageResult.vue?vue&type=style&index=0&id=51706315&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51706315"]])

export default __exports__